import { Component, computed, inject } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ConnectionStatusService } from '@shared/services/connection-status.service';

@Component({
  selector: 'app-connection-warning',
  imports: [TranslateModule],
  templateUrl: './connection-warning.component.html',
  styleUrl: './connection-warning.component.scss',
})
export class ConnectionWarningComponent {
  private connectionService = inject(ConnectionStatusService);

  status = this.connectionService.status;

  isVisible = computed(() => this.status() !== 'online');

  messageKey = computed(() => {
    switch (this.status()) {
      case 'offline':
        return 'NoConnection';
      case 'slow':
        return 'SlowConnection';
      default:
        return '';
    }
  });

  iconName = computed(() => {
    switch (this.status()) {
      case 'offline':
        return 'wifi_off';
      case 'slow':
        return 'signal_cellular_connected_no_internet_0_bar';
      default:
        return '';
    }
  });
}
